module.exports = __webpack_public_path__ + "img/sRomaII_350x350.67212eb5.jpg";